import { Component, forwardRef, Input } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "app-radiobutton",
  templateUrl: "input-radiobutton.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadiobuttonComponent),
      multi: true,
    },
  ],
})
export class RadiobuttonComponent implements ControlValueAccessor {
  @Input() label = "";
  @Input() name = ""; 
  @Input() optionValue: any; 
  @Input() disabled = false;
  @Input() required = false;
  @Input() readonly = false;
  @Input() error: string | null = null; 
  @Input() hint: string | null = null; 

  value: any;
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  handleInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (!target.checked) {
      return;
    }
    this.value = this.optionValue;
    this.onChange(this.value);
  }

  handleBlur(): void {
    this.onTouched();
  }
}